import _ from "lodash";
import { useEffect, useState, useCallback } from "react";
import Promise from "bluebird";
import { Box, Stack, Typography } from "@mui/material";
import Logo from "../../../utils/Logo";
import { toUrlName, downloadPdf } from "./utils";

const AutoDownloader = ({ urls }) => {
  const [isDownloading, setIsDownloading] = useState(false);
  const [downloaded, setDownloaded] = useState(false);
  const [error, setError] = useState(false);

  const handleDownload = useCallback((urls) => {
    setIsDownloading(true);
    setError(false);

    Promise.each(urls, (url, index) => {
      const id = toUrlName(url) || index;
      return downloadPdf(url, id);
    })
      .then(() => setDownloaded(true))
      .catch((err) => {
        console.error("Error downloading PDFs:", err);
        setError(true);
      })
      .finally(() => setIsDownloading(false));
  }, []);

  useEffect(() => {
    if (_.isEmpty(urls) || downloaded || isDownloading || error) return;
    handleDownload(urls);
  }, [urls, downloaded, isDownloading, error, handleDownload]);

  return (
    <Stack>
      <Box
        sx={{
          p: 4,
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <Logo width={"80px"} />
      </Box>

      <Typography variant="h6" textAlign="center" p={4}>
        {isDownloading && <div>Descargando prescripciones...</div>}
        {downloaded && (
          <div>Descarga completa! Ya podés cerrar esta pestaña.</div>
        )}
        {error && (
          <div>Error al descargar las prescripciones. Por favor, inténtelo nuevamente.</div>
        )}
        {!isDownloading && !downloaded && !error && (
          <div>Preparando descarga...</div>
        )}
      </Typography>
    </Stack>
  );
};

export default AutoDownloader;
